<template>
  <div>
    <div v-if="flag === 'android' && isWechat" class="black-bg">
      <img src="../assets/images/android_download_guide.png" alt="" class="guide">
    </div>
    <div class="download_logo"></div>
    <div class="download_btn" @click="handleClick"></div>
    <img src="../assets/images/download_phone.png" alt="" class="download_phone">
  </div>
</template>

<script>
export default {
  name: 'Fall',
  data () {
    return {
      flag: 'android',
      isWechat: false
    }
  },
  created () {
    this.checkPlatform()
  },
  methods: {
    checkPlatform () {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        this.flag = 'ios'
        window.location = 'https://apps.apple.com/cn/app/id1551086312'
      }
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        this.isWechat = true
      } else if (!(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent))) {
        window.location = 'https://erp-static.hfcfb.com/android-app/erp_xsjl.apk'
      }
    },
    handleClick () {
      location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.download_logo {
  width: 167px;
  height: 62px;
  position: fixed;
  left: 0;
  right: 0;
  top: 30px;
  margin: 0 auto;
  background: url("../assets/images/download_logo.png");
  background-size: 100% 100%;
}
.download_btn {
  width: 250px;
  height: 38px;
  position: fixed;
  left: 0;
  right: 0;
  top: 139px;
  margin: 0 auto;
  background: url("../assets/images/download_btn.png");
  background-size: 100% 100%;
}
.download_phone {
  display: block;
  width: 89.6%;
  height: auto;
  position: fixed;
  left: 0;
  right: 0;
  top: 201px;
  margin: 0 auto;
}
.black-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .7);
  z-index: 1;
  .guide {
    width: 258.5px;
    height: 285px;
    position: fixed;
    right: 28px;
    top: 0;
    z-index: 2;
  }
}
</style>
